import addToast from 'core/notifications/helpers/addToast';
import i18n from 'i18next';
import { handleAxiosError } from 'core/notifications';

export default (error) => {
  if (error.response?.status === 403) {
    addToast(i18n.t('error-forbidden'), 'error');
    return;
  }

  handleAxiosError(error);
};
